import template from './access-management-base.html';
import App from '../../app';

const AMPLITUDE_EVENT_NAME = "Page View: Access Management";
class AcessManagementController {
  constructor() {
    'ngInject';
  }

  $onInit() {
    App.amplitude.track(AMPLITUDE_EVENT_NAME);
  }
}
export default {
  template,
  controller: AcessManagementController,
  controllerAs: 'vm'
};
